import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=2d6908c0&scoped=true&"
import script from "./Composer.vue?vue&type=script&lang=ts&"
export * from "./Composer.vue?vue&type=script&lang=ts&"
import style0 from "./Composer.vue?vue&type=style&index=0&id=2d6908c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6908c0",
  null
  
)

export default component.exports